import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

import moment from 'moment-timezone';
import { TimezoneService } from '@services/timezone.service';

@Pipe({
  name: 'unixTimestamp',
})
export class UnixTimestampPipe implements PipeTransform {
  private userTimezone: string;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private readonly datePipe: DatePipe,
    private readonly timezoneService: TimezoneService,
  ) {
    this.timezoneService.timezone.subscribe((tz) => (this.userTimezone = tz));
  }

  transform(value: number, format = 'mediumDate', timezone = ''): string {
    const unixTimestamp = moment.unix(value).format();

    if (timezone) {
      return this.datePipe.transform(unixTimestamp, format, timezone, this.locale);
    }
    if (value && this.userTimezone) {
      const timezoneFormatted = moment.utc(unixTimestamp).tz(this.userTimezone).format('YYYY-MM-DD HH:mm:ss');
      return this.datePipe.transform(timezoneFormatted, format, '', this.locale);
    }
    return '';
  }
}
